import { LuMoveRight } from "react-icons/lu";
import { CommonServiceContext } from "../../../services/common/commonService";
import { useContext, useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { Link } from "react-router-dom";

const News = () => {
  const { news, getHomePage, loading } = useContext(CommonServiceContext);

  useEffect(() => {
    getNews();
  }, []);

  const getNews = async () => {
    await getHomePage();
  };

  return (
    <>
      {loading && <Loader />}
      <div className="container">
        <section id="news" className="py-10 lg:py-20 mt-80">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-1 2xl:grid-cols-1">
            <div className="mx-auto mb-12 max-w-xl text-center">
              <span className="rounded-md border border-primary bg-primary/20 px-3 py-1 text-xs font-medium uppercase tracking-wider text-primary">
                სიახლეები
              </span>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 2xl:grid-cols-3">
            {news &&
              news.length > 0 &&
              news.map((item, idx) => {
                return (
                  <div key={idx}>
                    <div className="flex flex-wrap gap-5 rounded-lg border border-default-200 bg-white p-6 shadow dark:bg-default-50 md:flex-nowrap">
                      {/* <div>
                      <div className="flex size-10 items-center justify-center rounded-md bg-default-900 text-xl text-default-50">
                        {idx + 1}
                      </div>
                    </div> */}
                      <div>
                        <img
                          src={item.bgImageUrl}
                          alt="Example Image"
                          className="w-full rounded-lg object-cover"
                        />
                        <h3 className="mb-4 text-md font-medium text-default-950 md:text-xl h-24">
                          {item.name}
                        </h3>
                        <p className="mb-4 font-medium md:text-base">
                          {item.description}
                        </p>
                        <Link
                          className="group text-md font-medium text-default-950"
                          // onClick={() => handleServiceClick(service.id)}
                          to={`/news/${item.id}`}
                        >
                          გაიგეთ მეტი
                          <LuMoveRight className="inline-block size-6 opacity-0 transition-all duration-500 will-change-transform group-hover:translate-x-2 group-hover:opacity-100" />
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </section>
      </div>
    </>
  );
};

export default News;
